<template>
  <div></div>
</template>

<script>
export default {
  created() {
    this.$gtm.trackEvent({ event: 'init-profile' })
  },
}
</script>
